<template>
    <div>
        <div class="futuro" style="margin-top: 150px!important;">
            <top-shape :background="'#59C3C3'"></top-shape>
            <div class="container py-5">
                <div class="row">
                    <div class="col-md mb-3">
                        <h1>El futuro del Talmud depende de ti</h1>
                        <h5 class="mb-4 font-weight-normal">La Torá que recibiste fue donada por alguien para ti.  ¿Te gustaría donarla tú también? Vamos a distribuir un millon de horas de estudio gracias a la nueva generación de la plataforma Jabrutouch.</h5>
                        <button @click="$emit('openDonations')" class="btn btn-lg btn-secondary">Regala Ketarim</button>
                        <button @click="$emit('openKetarim')" class="btn btn-lg btn-light ml-3">Saber más</button>
                    </div>
                    <div class="col-md text-right">
                        <a href="#" @click.prevent="$store.state.videoVisible = true"><img :src="require('../assets/images/spoons.png')" class="img-fluid"></a>
                    </div>
                </div>
            </div>
        </div>
        <lightbox :url="'https://www.youtube.com/embed/TMwokad28V4'"/>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
    .futuro, .futuro{
        background: #59C3C3;
    }
</style>